import { ShopifyLocalCheckoutLineItem } from '../../../types/api/entities/shopify';

export interface AddCheckoutLineItemsAction {
  type: 'SHOPIFY/ADD_CHECKOUT_LINE_ITEMS';
  payload: {
    recipeId: number;
    lineItems: ShopifyLocalCheckoutLineItem[];
  };
}

export function addCheckoutLineItems(
  recipeId: number,
  lineItems: ShopifyLocalCheckoutLineItem[],
): AddCheckoutLineItemsAction {
  return {
    type: 'SHOPIFY/ADD_CHECKOUT_LINE_ITEMS',
    payload: {
      recipeId,
      lineItems,
    },
  };
}
